<template>
  <div class="affirmorderindex1">
    <top-nav1 ref="TopNav1"></top-nav1>
    <div class="pop" v-if="lodingshow">
      <van-loading type="spinner" />
    </div>
    <van-nav-bar style="background: #F1F1F1" title="确认订单" fixed left-arrow @click-left="goBack">
      <van-icon slot="right" @click="onClickRight()" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar>
    <div style="padding-bottom: 72px" class="van-content">
      <!--地址-->
      <div
        v-if="dummy != 2 && dummy != 3 && getid != ''"
        class="van-cell-group van-hairline--top-bottom hasAddress"
      >
        <div
          @click="addsite"
          class="van-cell van-cell--clickable van-address-item"
        >
          <div style="padding-right: 19px" class="van-cell__value van-cell__value--alone">
            <div class="van-radio" style="position: relative">
              <span style="padding-left: 0" class="van-radio__label">
                <div class="van-address-item__name col-18">
                  {{getname}}
                  <span class="col-18" style="margin-left: 30px">{{gettel}}</span>
                </div>
                <div class="van-address-item__address col-29">{{getaddress}}</div>
                <div class="van-address-item__address col-29">{{getaddress1}}</div>
              </span>
            </div>
          </div>
          <van-icon
            style="position: absolute; right: 20px; top: 50%;margin-top: -8px;font-size: .32rem;right: 15px"
            name="arrow"
          />
        </div>
      </div>
      <!--<router-link v-if="dummy != 2 && dummy != 3 "  to="user/mysite/addsite" class="van-cell-group van-hairline&#45;&#45;top-bottom" >-->
      <div
        @click="addsite"
        v-if="dummy != 2 && dummy != 3 &&getid == ''"
        class="van-cell-group van-hairline--top-bottom"
      >
        <div class="van-cell van-hairline add_address">
          <div class="van-cell__value van-cell__value--alone">
            请添加收货地址
            <i
              style="font-size: .32rem;line-height: 24px;"
              class="van-icon van-icon-arrow van-notice-bar__right-icon"
            ></i>
          </div>
        </div>
        <!--商品信息-->
      </div>
      <div style="padding: 0 15px">
        <img src="/static/images/eline.png" alt />
      </div>
      <div class="van-cell-group" style="margin-bottom: 0">
        <div style="padding-bottom: 0" class="van-cell">
          <span
            class="fw ft15"
            style="display: inline-block;width: 100%;border-bottom: 1px solid #eee;padding-bottom: 10px"
          >商品信息</span>
        </div>
      </div>
      <div class="one">
        <van-card class="goodsonelist">
          <div slot="thumb" class="goodsimgbox">
            <img class="radius6" :src="datas.image" onerror="src='/static/errorimg1.png'" />
          </div>
          <div style="margin-top: 8px;height: 40px;" slot="title" class="ellipseal van-card-title">
            <!--<span class=" radius theme-bg theme-bd  " v-if="dummy == 4">一乡一物</span>-->
            <!--<span class="  radius theme-hot " v-if="dummy == 3">卡券</span>-->
            <!--<span class="  radius theme-bg theme-bd " v-if="dummy == 2">直充</span>-->
            <span plain class="jd1" v-if="dummy == 1">优选</span>
            <span class="yx1" v-if="dummy == 6">严选</span>
            <span class="ft15">{{ datas.name}}</span>
          </div>
          <div style="bottom: 15px" slot="footer">
            <div class="col-6a" style="position: relative;top: -20px;z-index: 99;">× 1</div>
          </div>
        </van-card>
      </div>
      <!--备注-->
      <div v-if="dummy != 2 && dummy != 3" class="van-cell van-hairline van-field beizhu">
        <div style="max-width: 40px" class="van-cell__title">
          <span>备注</span>
        </div>
        <div style="min-width: 100px" class="van-cell__value">
          <textarea
            @input="descInput"
            placeholder="选填，文字限制在45字以内"
            v-model="content"
            class="van-field__control"
          ></textarea>
        </div>
      </div>
      <van-goods-action style="padding: 0 15px 20px 15px" v-if="nostock==false">
        <van-button
          :disabled="btnLoading==false"
          class="success-btn"
          @click="sendDadas"
          color="red"
          text="确认订单"
        />
      </van-goods-action>
      <van-goods-action style="padding: 0 15px 20px 15px" v-if="nostock==true">
        <van-button
          :disabled="nostock==true"
          class="success-btn"
          color="red"
          @click="sendDadas"
          text="暂无库存"
        />
      </van-goods-action>
    </div>

    <!--缺货状态弹框-->
    <van-popup v-model="newshow" class="adven-popup userlist-popup">
      <div class="hintbox">
        <span class="dot theme-bg"></span>
        <h2 class="title">提示</h2>
        <h3 class="title1">您挑选的礼品在当前配送地址库存不足，请重新填写地址或挑选其它礼品</h3>
        <div class="newclose">
          <button class="theme-bg thmem-bd" @click="closePop">确定</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Bus from "../../../static/js/bus.js";
import TopNav1 from "../../components/topnav1";
export default {
  name: "index",
  components: {
    TopNav1
  },
  data() {
    return {
      btnLoading: true, //提交按钮状态
      datas: "", //商品数据
      chosenAddressId: "", //收货地址ID
      mobile: "", //手机号
      content: "", //备注
      dummy: "", //是否是虚拟商品
      getname: "",
      getid: "",
      gettel: "",
      getaddress: "",
      getaddress1: "",
      newshow: false,
      lodingshow: true,
      ajaxfrom: {},
      data: [], //无库存列表信息
      nostock: false,
      gid: this.$route.query.gid
    };
  },
  computed: {
    id: function() {
      if (typeof this.$route.query.id == "string") {
        return this.$route.query.id;
      } else {
        //多个订单id并转为字符串的形式
        return this.$route.query.id.join(",");
      }
    }
  },
  methods: {
    goBack: function() {
      history.back(-1);
    },
    godetail: function(id) {
      this.$router.push({
        path: "/goodslist/goods",
        query: { id: id, gid: this.gid }
      });
    },
    closePop: function() {
      this.newshow = false;
    },
    onClickRight() {
      this.$refs.TopNav1.topnavPlay();
    },
    descInput() {
      var txtVal = this.content.length; //desc 是设置v-model的值
      if (txtVal > 45) {
        this.content = this.content.slice(0, 45);
        this.$dialog
          .alert({
            title: "提示",
            message: "字数不能超过45个字！"
          })
          .then(() => {
            // on close
          });
      }
    },
    getDatas: function() {
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      var _this = this;
      this.$api.get(
        "active/order/information",
        { id_active: this.gid, token_user: isUser, id_order: this.id },
        res => {
          if (res.data.code != "100") {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({
                    name: "Elogin",
                    query: { gid: this.gid }
                  });
                })
                .catch(() => {});
            } else if (res.data.code == "1001") {
              this.$router.push({
                name: "Edetail",
                query: {
                  gid: this.gid,
                  id: res.data.message.products.id_product
                }
              });
            } else {
              //              this.$toast(res.data.message);
              this.goBack();
            }
          } else {
            if (res.data.data.products.length == 0) {
              this.goBack();
            } else {
              _this.lodingshow = false;
              _this.datas = res.data.data.products;
              _this.dummy = res.data.data.data.source;
              _this.getAddress();
            }
          }
        },
        err => {
          this.$toast("服务器繁忙，请稍后再试");
        }
      );
    },
    getAddress: function() {
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      var _this = this;
      this.$api.get(
        "active/address",
        { id_active: this.gid, token_user: isUser },
        res => {
          if (res.data.code == "100") {
            if (res.data.data.id != "" || res.data.data.id != null) {
              if (this.dummy == 1) {
                this.checkStock(
                  res.data.data.province,
                  res.data.data.city,
                  res.data.data.county,
                  res.data.data.town
                ); //查询库存
                this.province = res.data.data.province;
                this.city = res.data.data.city;
                this.county = res.data.data.county;
                this.town = res.data.data.town;
              }
            }
            this.chosenAddressId = res.data.data.id;
            this.getname = res.data.data.name;
            this.getid = res.data.data.id;
            this.gettel = res.data.data.phone;
            this.getaddress =
              res.data.data.province_str +
              res.data.data.city_str +
              res.data.data.county_str +
              res.data.data.town_str;
            this.getaddress1 = res.data.data.address;
            this.lodingshow = false;
          }
        },
        err => {
          this.$toast("服务器繁忙，请稍后再试");
        }
      );
    },
    checkStock: function(province, city, county, town) {
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      var _this = this;
      this.$api.get(
        "active/order/stock",
        {
          id_active: this.gid,
          token_user: isUser,
          id_product: this.datas.id_product,
          id_province: province,
          id_city: city,
          id_county: county,
          id_town: town
        },
        res => {
          if (res.data.code == "100") {
            if (res.data.data.result == 0) {
              this.newshow = true;
              this.nostock = true;
            }
          }
        },
        err => {
          this.$toast("服务器繁忙，请稍后再试");
        }
      );
    },
    addsite: function() {
      this.$router.push({
        path: "/eaddsite",
        query: { id: this.chosenAddressId, gid: this.gid }
      });
    },

    sure: function() {
      this.data = [];
      if (this.chosenAddressId == "") {
        this.$toast("请先添加收货地址");
        this.btnLoading = true;
        return false;
      }
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var _this = this;
      this.$api.post(
        "active/order/confirm",
        this.ajaxfrom,
        res => {
          if (res.data.code == "100") {
            this.$dialog
              .confirm({
                title: "提示",
                message: "确定提交订单，订单提交成功不可取消"
              })
              .then(() => {
                this.pay(res.data.data.id_order);
              })
              .catch(() => {
                this.btnLoading = true;
                // on cancel去未支付订单详情
                this.$router.push({
                  name: "Edetail",
                  query: { id: this.datas.id_product, gid: this.gid }
                });
                //this.$router.push({name: 'Eorderlist'})
              });
          } else if (res.data.code == "-88") {
            //余额不足
            this.btnLoading = true;
            this.$toast(res.data.data);
          } else if (res.data.code == "-99") {
            //库存不足
            this.btnLoading = true;
            this.$$toast(res.data.data);
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({
                    name: "Elogin",
                    query: { gid: this.gid }
                  });
                })
                .catch(() => {
                  this.btnLoading = true;
                });
            } else {
              this.btnLoading = true;
              this.$toast(res.data.message);
            }
          }
        },
        err => {
          this.$toast("服务器繁忙，请稍后再试");
        }
      );
    },
    pay: function(id) {
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      this.$api.post(
        "active/order/pay",
        { id_active: this.gid, token_user: isUser, id_order: id },
        res => {
          if (res.data.code == "100") {
            this.$router.push({
              name: "Eordersucceed",
              query: { orderId: id, gid: this.gid }
            });
          } else {
            if (res.data.message == "token验证失败") {
              this.$dialog
                .confirm({
                  title: "提示 ",
                  message: "您还未登录是否去登录？"
                })
                .then(() => {
                  this.$router.push({
                    name: "Elogin",
                    query: { gid: this.gid }
                  });
                })
                .catch(() => {});
            } else {
              this.$toast(res.data.message);
            }
          }
        }
      );
    },

    sendDadas: function() {
      this.data = [];
      var isUser = localStorage.getItem("ECuser");
      var mallid = localStorage.getItem("mallid");
      var gid = localStorage.getItem("gid");
      this.btnLoading = false;
      this.ajaxfrom.id_active = this.gid;
      this.ajaxfrom.token_user = isUser;
      this.ajaxfrom.id_order = this.id;
      this.ajaxfrom.remark = this.content;
      this.ajaxfrom.id_address = this.chosenAddressId;
      // this.ajaxfrom.id_province=this.id_product
      // this.ajaxfrom.id_city=this.city
      // this.ajaxfrom.id_county=this.county
      // this.ajaxfrom.id_town=this.town
      this.sure();
    }
  },
  mounted() {
    this.getDatas();
    $("body").css("background", "#fff");
  },
  destroyed: function() {
    $("body").css("background", "#EFF3F6");
  }
};
</script>

<style lang="less">
.affirmorderindex1 {
  padding-top: 0.9rem;
  img {
    width: 100%;
  }
  .van-hairline--bottom.van-nav-bar.van-nav-bar--fixed .van-nav-bar__title {
    text-align: center;
    font-weight: bold;
  }
  .van-goods-action-big-btn {
    border-radius: 6px;
    background: linear-gradient(left, #ef5033, #ff397a);
    background: -webkit-linear-gradient(left, #ef5033, black) !important;
    background: -o-linear-gradient(left, #ef5033, black) !important;
    background: -moz-linear-gradient(left, #ef5033, black) !important;
    background: -ms-linear-gradient(left, #ef5033, #ff397a) !important;
  }
  input::-webkit-input-placeholder {
    color: #999 !important;
  }
  .pop {
    background-color: #fff !important;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 100;
    .van-loading {
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -15px 0 0 -15px;
    }
  }

  .addressList {
    background: transparent !important;
    .van-radio-group {
      background: transparent !important;
    }
    .van-cell-group {
      background: #f5f5f5;
      .van-cell {
        margin-bottom: 10px;
      }
    }
  }

  .van-field {
    .van-cell__title {
      max-width: 110px;
    }
  }
  .van-cell:not(:last-child)::after {
    border-bottom-width: 0;
  }
  .van-address-list__add {
    display: none;
  }
  .hasAddress {
    .van-cell {
      padding-bottom: 0px;
      background: #fff;
      padding: 15px 15px;
    }
  }
  .van-address-list__group {
    padding-bottom: 0px;
    background: #fff;
  }

  .one {
    padding: 0 15px;
    .goodsonelist {
      height: 100px;
      border-bottom: 1px solid #eee;
      padding-left: 100px;
      margin: 0 !important;
      background: #fff;
      padding: 5px 0px 5px 5px !important;
      .van-card__thumb {
        left: 0;
      }
      .van-card__right {
        display: none;
      }
    }
  }

  .add_address {
    height: 44px;
    background-color: #fff;
    padding: 0.2rem 0.3rem;
    box-sizing: content-box;
    .van-notice-bar__right-icon {
      right: 0px;
      top: 0;
    }
    .van-cell__value {
      height: 24px;
      font-size: .3rem;
      font-weight: bold;
      top: 50%;
      margin-top: -10px;
      vertical-align: middle;
      display: flex;
      align-items: center;
    }
  }
  .allinfo {
    padding: 15px;
    text-align: right;
    position: relative;
  }
  .allinfo:before {
    content: "";
    width: 100%;
    height: 1px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: #eee;
  }
  .allinfo:after {
    content: "";
    width: 100%;
    height: 1px;
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #eee;
  }
  .beizhu {
    .van-cell__title,
    .van-cell__value,
    .van-field__control {
      height: 24px;
      /*min-width: 60px !important;*/
    }
  }
  /*消息弹框*/
  .userlist-popup {
    background-color: inherit;
    width: 70%;
    border-radius: 6px;
    .hintbox {
      position: relative;
      .dot {
        display: inline-block;
        width: 25px;
        height: 5px;
        border-radius: 5px;
        margin: auto;
        position: absolute;
        top: 15px;
        left: 50%;
        margin-left: -13px;
      }
      .title {
        padding-top: 30px;
        border-radius: 6px 6px 0 0;
        text-align: center;
        font-size: .32rem;
        background: #fff;
      }
      .title1 {
        padding: 15px 30px;
        text-align: center;
        font-size: .28rem;
        background: #fff;
        color: #0f213470;
        margin-top: -1px;
      }
      .newclose {
        height: 50px;
        text-align: center;
        padding: 0;
        background: #fff;
        border-radius: 0 0 6px 6px;
        margin-top: -1px;
        padding: 0 15px 15px 15px;
        button {
          height: 40px;
          width: 100%;
          border-radius: 6px;
          border: 0 !important;
          color: #fff;
          background: linear-gradient(left, #ef5033, #ff397a);
          background: -webkit-linear-gradient(left, #ef5033, black) !important;
          background: -o-linear-gradient(left, #ef5033, black) !important;
          background: -moz-linear-gradient(left, #ef5033, black) !important;
          background: -ms-linear-gradient(left, #ef5033, #ff397a) !important;
        }
      }
    }
  }

  .success-btn {
    width: 100% !important;
    color: #fff !important;
    background-color: red !important;
    border-radius: 0.08rem;
  }

  .van-nav-bar {
    .van-icon {
      font-size: .4rem !important;
    }
  }
}
.theme-bg,.van-checkbox--checked,.van-swipe__indicator--active{background-color:red!important;color:#ffffff!important}
.theme-col,.van-icon-checked{color: red!important;}
.col-hover:hover{color: red!important;}
.col-on{color: red!important;}
.col-focus:focus{color: red!important;}
.col-checked:checked:before{
  color: red!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/exchange/ordercomit.vue